import React, { useState, useEffect } from "react";

const CheckboxGroup = ({ groupLabel, items, values, onChange, disabled }) => {
  const [expanded, setExpanded] = useState(false);

  // master checked when all children are true
  const masterChecked = items.length > 0 && items.every((item) => values[item]);

  const handleMasterChange = (e) => {
    const { checked } = e.target;
    const updated = {};
    items.forEach((item) => (updated[item] = checked));
    onChange(updated);
  };

  const handleChildChange = (item, checked) => {
    onChange({ [item]: checked });
  };

  return (
    <div
      className="mb-2 "
      style={{
        border: "1px solid var(--input-border-color)",
        borderRadius: "6px",
        boxSizing: "border-box",
        backgroundColor: "var(--input-bg-color)",
        color: "var(--input-text-color)",
        transition:
          "background-color var(--transition-speed), color var(--transition-speed), border-color var(--transition-speed), box-shadow var(--transition-speed)",
      }}
    >
      {/* Master checkbox + label */}
      <div className="d-flex align-items-center justify-content-between ">
        <input
          type="checkbox"
          className="form-check-input m-0 ms-2  "
          id={`${groupLabel}-master`}
          checked={masterChecked}
          onChange={handleMasterChange}
          disabled={disabled}
        />
        <span
          className="d-flex align-items-center justify-content-between w-100 "
          style={{
            padding: "0.5rem",
            borderRadius: "6px",
          }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          <label
            className="form-label mb-0 ml-4"
            // htmlFor={`${groupLabel}-master`} // this will allow if on click on abel it will tick check box.
            // onClick={() => setExpanded((prev) => !prev)}
            style={{ cursor: "pointer" }}
          >
            {groupLabel}
          </label>
          <span>{expanded ? "▲" : "▼"}</span>
        </span>
      </div>
      {/* Children checkboxes */}
      {expanded &&
        items.map((item) => (
          <div key={item} className="form-check ms-4">
            <input
              type="checkbox"
              className="form-check-input"
              id={`${groupLabel}-${item}`}
              checked={!!values[item]}
              onChange={(e) => handleChildChange(item, e.target.checked)}
              disabled={disabled}
            />
            <label
              className="form-check-label"
              htmlFor={`${groupLabel}-${item}`}
            >
              {item.replace(/_/g, " ")}
            </label>
          </div>
        ))}
    </div>
  );
};

export default CheckboxGroup;
